import { ColumnSettings, ColumnTypes, TableFilterType } from '@app/sharedModule/models/table-settings.model';
import { DeliveryPromiseLabel, FlaggedStatuses } from '@app/services/order/order.model';
import { TranslatedPaymentStatus, TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';
import { OrderStatus } from '@pdqdev/pdq-shared/dist/entities';

export const previewColumnsConfig: ColumnSettings[] = [
  {
    type: ColumnTypes.CHECKBOX,
    prop: 'checkbox',
    hideColumnName: true,
    sortable: false,
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    withValidationIcon: true,
  },
  {
    type: ColumnTypes.COLOR,
    prop: 'colorCoding',
    name: 'Color coding',
    filterType: TableFilterType.COLOR,
    filterOption: 'IN',
    filterValueArray: [],
    sortDirection: null,
    width: 70,
    minWidth: 70,
    maxWidth: 120,
    canBeHide: true,
    default: true,
  },
  {
    sortDirection: null,
    prop: 'orderNumber',
    name: 'Order no.',
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    fraudRisk: true,
    withExchange: true,
    pendingPayment: true,
    inventoryOutOfStock: true,
    weather: true,
    split: true,
    merged: true,
    width: 90,
    minWidth: 90,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'externalOrderNumber',
    name: 'External order number',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'itemCount',
    name: 'Items',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: true,
    canBeHide: true,
  },
  {
    prop: 'zone',
    name: 'Zone',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: false,
    canBeHide: true,
  },
  {
    type: ColumnTypes.DATE,
    prop: 'createdDate',
    name: 'Date ordered',
    width: 110,
    minWidth: 90,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    filterFields: 'createdDate',
    filterValue: '',
    sortDirection: null,
    headerTitleIcon: true,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'customerFormated',
    name: 'Bill to',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    sortFieldName: ['customer'],
    default: true,
    canBeHide: true,
  },
  {
    prop: 'shippingAddressFormatted',
    name: 'Ship to',
    width: 180,
    minWidth: 180,
    withNote: true,
    type: ColumnTypes.POPOVER_COLUMN,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['customer.ordersCount'],
    withLoyalty: true,
    default: true,
    canBeHide: true,
  },
  {
    prop: 'shippingAddress.province',
    name: 'Ship to state',
    width: 120,
    minWidth: 120,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'shippingAddress.country',
    name: 'Ship to country',
    width: 140,
    minWidth: 140,
    filterType: TableFilterType.TEXT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shippingAddress'],
    default: false,
    canBeHide: true,
  },
  {
    prop: 'shipFromAddress.storeName',
    name: 'Inventory location',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.SELECT,
    filterValue: '',
    filterOption: 'LIKE',
    sortDirection: null,
    sortFieldName: ['shipFromAddress'],
    default: true,
    canBeHide: true,
    filterSelectOptions: [],
  },
  {
    prop: 'deliveryMethod',
    name: 'Delivery method',
    width: 100,
    minWidth: 137,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    default: true,
    canBeHide: true,
  },
  {
    prop: 'shippingPhone',
    name: 'Phone number',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: '',
  },
  {
    prop: 'totalTagsCount',
    name: 'Tags',
    type: ColumnTypes.POPOVER_COLUMN,
    width: 80,
    minWidth: 80,
    filterType: TableFilterType.TAGS,
    filterOption: 'IN',
    filterValue: '',
    filterValueArray: [],
    default: false,
    sortDirection: '',
    canBeHide: true,
    tooltipText: 'View all tags',
    scrollSection: 'orderTagsId',
    zeroStateText: 'tag',
  },
  {
    prop: 'box.name',
    name: 'Package name',
    filterType: TableFilterType.SELECT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['box.name'],
    filterSelectOptions: [],
  },
  {
    prop: 'skus',
    name: `SKUs`,
    filterType: TableFilterType.TEXT,
    type: ColumnTypes.POPOVER_COLUMN,
    width: 100,
    minWidth: 100,
    filterOption: 'LIKE',
    filterValue: '',
    default: false,
    sortDirection: '',
    canBeHide: true,
    sortFieldName: ['skus'],
    tooltipText: 'View all skus',
    scrollSection: 'orderDetailsId',
    zeroStateText: 'SKU',
  },
  {
    prop: 'paymentStatus',
    name: 'Payment status',
    type: ColumnTypes.PAYMENT,
    width: 131,
    minWidth: 131,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: TranslatedPaymentStatus.PAID,
        text: 'Paid',
      },
      {
        value: TranslatedPaymentStatus.UNPAID,
        text: 'Unpaid',
      },
      {
        value: TranslatedPaymentStatus.REFUNDED,
        text: 'Refunded',
      },
      {
        value: TranslatedPaymentStatus.AUTHORIZED,
        text: 'Authorized',
      },
      {
        value: TranslatedPaymentStatus.CANCELLED,
        text: 'Cancelled',
      },
      {
        value: TranslatedPaymentStatus.PARTIALLY_PAID,
        text: 'Partially paid',
      },
      {
        value: TranslatedPaymentStatus.PARTIALLY_REFUNDED,
        text: 'Partially refunded',
      },
    ],
    filterOption: 'IN',
    sortDirection: '',
    default: true,
    canBeHide: true,
  },
  {
    prop: 'fulfillmentStatus',
    name: 'Fulfillment status',
    type: ColumnTypes.FULFILLMENT,
    width: 100,
    minWidth: 100,
    maxWidth: 120,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: TranslatedFulfillmentStatus.FULFILLED,
        text: 'Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.PARTIALLY_FULFILLED,
        text: 'Partially Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.NOT_FULFILLED,
        text: 'Unfulfilled',
      },
    ],
    filterOption: 'LIKE',
    sortDirection: '',
    canBeHide: true,
    default: true,
  },
  {
    prop: 'merchantShippingDate',
    name: 'Ship on',
    type: ColumnTypes.DATE,
    dateFormat: 'MMM dd',
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    width: 110,
    minWidth: 90,
    maxWidth: 200,
    filterFields: 'merchantShippingDate',
    sortFieldName: ['merchantShippingDate'],
    canBeHide: true,
  },
  {
    type: ColumnTypes.VALIDATED_STATUS,
    prop: 'orderStatus',
    name: 'Status',
    width: 110,
    minWidth: 110,
    filterType: TableFilterType.SELECT,
    isFilterMultiple: false,
    isFilterGrid: true,
    filterSelectOptions: [
      {
        value: FlaggedStatuses.VERIFIED,
        text: 'Verified',
      },
      {
        value: OrderStatus.FIX_NOT_VERIFIED,
        text: 'Not verified',
      },
      {
        value: OrderStatus.FIX_ADDRESS,
        text: 'Fix address',
      },
      {
        value: FlaggedStatuses.MISSING_ADDRESS,
        text: 'Address missing',
      },
      {
        value: OrderStatus.FIX_PHONE,
        text: 'Fix phone',
      },
      {
        value: FlaggedStatuses.MISSING_PHONE,
        text: 'Phone missing',
      },
      {
        value: OrderStatus.FIX_INTERNATIONAL,
        text: 'Fix international',
      },
      {
        value: OrderStatus.FIX_FRAUD_RISK,
        text: 'Fraud risk',
      },
      {
        value: FlaggedStatuses.FOR_PICKUP,
        text: 'For pickup',
      },
      {
        value: DeliveryPromiseLabel.POS,
        text: 'Point of sale',
      },
      {
        value: FlaggedStatuses.GIFT_CARD,
        text: 'Gift card',
      },
      {
        value: OrderStatus.FIX_MEASURES,
        text: 'Missing weight',
      },
      {
        value: OrderStatus.FIX_BOX,
        text: 'Package missing',
      },
      {
        value: OrderStatus.FIX_PENDING,
        text: 'Pending payment',
      },
      {
        value: OrderStatus.FIX_INVENTORY_OUT_OF_STOCK,
        text: 'Missing inventory',
      },
      {
        value: OrderStatus.FIX_SPLIT,
        text: 'Split required',
      },
      {
        value: OrderStatus.FIX_WEATHER,
        text: 'Weather alert',
      },
      {
        value: OrderStatus.CANCELED,
        text: 'Cancelled',
      },
      {
        value: TranslatedPaymentStatus.REFUNDED,
        text: 'Refunded',
      },
      {
        value: TranslatedPaymentStatus.PARTIALLY_REFUNDED,
        text: 'Partially refunded',
      },
      {
        value: OrderStatus.FIX_ON_HOLD,
        text: 'On hold',
      },
    ],
    filterOption: 'IN',
    sortDirection: '',
    sortFieldName: ['orderStatus', 'paymentStatus'],
  },
  {
    prop: 'deliveryPromise',
    name: 'Delivery promise',
    type: ColumnTypes.DELIVERY_PROMISE,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    width: 190,
    minWidth: 190,
    maxWidth: 260,
    filterFields: 'deliveryDate',
    sortFieldName: ['deliveryDate'],
    default: false,
    canBeHide: true,
  },
];
